import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marketreturns',
  templateUrl: './marketreturns.component.html',
  styleUrls: ['./marketreturns.component.css']
})
export class MarketreturnsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
